var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app-wrapper"},[(this.$store.state.postLoaded)?_c('div',{staticClass:"app"},[(!_vm.navigationDisable)?_c('Navigation'):_vm._e(),_c('router-view'),(!_vm.navigationDisable)?_c('Footer'):_vm._e()],1):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }